import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'antd';
import {
    UserOutlined,
    UnorderedListOutlined,
    UsergroupAddOutlined,
    ExclamationCircleOutlined,
    MoneyCollectOutlined,
    TransactionOutlined,
    MailOutlined,
    NotificationOutlined
} from '@ant-design/icons';

function GestClienteopc() {
    const history = useHistory();

    const menuItems = [
        { key: 'pesquisarCliente', label: 'Pesquisar Cliente', icon: <UserOutlined />, onClick: () => history.push('/home/gest-cliente/pesquisar-cliente') },
        { key: 'listarCliente', label: 'Listar Cliente', icon: <UnorderedListOutlined />, onClick: () => history.push('/home/gest-cliente/listar-cliente') },
        { key: 'importarClientes', label: 'Importar Clientes', icon: <UsergroupAddOutlined />, onClick: () => history.push('/home/registar-cliente') },
        { key: 'reclamacoes', label: 'Reclamações', icon: <ExclamationCircleOutlined />, onClick: () => history.push('/home/gest-cliente/reclamacoes') },
        { key: 'dividas', label: 'Dívidas', icon: <MoneyCollectOutlined />, onClick: () => history.push('/home/gest-cliente/Dividas') },
        { key: 'refund', label: 'Refund', icon: <TransactionOutlined />, onClick: () => history.push('/home/gest-cliente/refund') },
        { key: 'centroNotificacao', label: 'Centro de Notificação', icon: <NotificationOutlined />, onClick: () => history.push('/home/gest-cliente/gateway') },
        { key: 'gmail', label: 'Gmail', icon: <MailOutlined /> }
    ];

    const handleClick = (item) => {
        if (item.onClick) {
            item.onClick();
        }
    };

    return (
        <Menu mode="horizontal" onClick={({ key }) => handleClick(menuItems.find(item => item.key === key))}>
            {menuItems.map(item => (
                <Menu.Item key={item.key} icon={item.icon}>
                    {item.label}
                </Menu.Item>
            ))}
        </Menu>
    )
}

export default GestClienteopc;
